import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const jobsApi = createApi({
    reducerPath: "jobsApi",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["Job"],
    endpoints: (builder) => ({

        getAllJobs: builder.query({
            query: ({ pageno, search, status, role, sort ,sortOrder ,sortBy, limit }) => {
                let url = `/${role}/jobs?pageno=${pageno}`;
                if (search) {
                    url += `&search=${search}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if (sort) {
                    url += `&sort=${sort}`;
                }
                if (sortOrder){
                     url += `&sortOrder=${sortOrder}`
                };
                if (sortBy) {
                    url += `&sortBy=${sortBy}`
                };
                if (limit) {
                    url += `&limit=${limit}`
                };
                return {
                    url,
                    method: "GET",
                };
            },
            providesTags: ["Job"],
        }),

        getJobById: builder.query({
            query: ({ id, role }) => ({
                url: `/${role}/job/${id}`,
                method: "GET",
            }),
            providesTags: ["Job"],
            transformResponse: (response) => response?.body,
        }),

        addJob: builder.mutation({
            query: (data) => ({
                url: `/contractor/job`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Job"],
        }),

        updateJob: builder.mutation({
            query: ({ id, data }) => ({
                url: `/contractor/job/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Job"],
        }),

        deleteJob: builder.mutation({
            query: (id) => ({
                url: `/contractor/job/${id}/delete`,
                method: "DELETE",
            }),
            invalidatesTags: ["Job"],
        }),
        getAllJobTypes: builder.query({
            query: ({ pageno = 1, search, sort ,dropdown} = {}) => {
                let url = `/contractor/job-types?pageno=${pageno}`;
                if (search) url += `&search=${search}`;
                if (sort) url += `&sort=${sort}`;
                if (dropdown) url += `&dropdown=${dropdown}`;
                return { url, method: "GET" };
            },
            providesTags: ["JobType"],
            transformResponse: (response) => response?.body || response,
        }),
        getEstimatorTemplate: builder.query({
            query: () => ({
                url: `/contractor/estimator_templates`,
                method: 'GET',
            }),
            provideTags: ['jobType'],
            transformResponse: (response) => response?.body || response,
        }),
        createEstimate: builder.mutation({
            query: ({ job_id, data }) => ({
                url: `/contractor/job/${job_id}/estimate/assign`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Job"],
        }),
        createQuote: builder.mutation({
            query: ({ job_id, data }) => ({
                url: `contractor/job/${job_id}/quote`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Job"],
        }),
        getJobByDates: builder.query({
            query: ({ role, date, path }) => {
                console.log("role, date, path", role, date, path);
                return {
                    url: `/${role}/job/calendar/${path}?date=${date}`,
                    method: "GET",
                }
              },
            providesTags: ["Job"],
        }),

        assignTechnicianToJob: builder.mutation({
            query: ({ job_id, data , technician_id }) => ({
                url: `/contractor/job/${job_id}/technician/${technician_id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Job"],
        }),

        cancelJob: builder.mutation({
            query: ({ job_id }) => ({
                url: `/contractor/job/${job_id}/cancel`,
                method: "DELETE",
                body: {},
            }),
            invalidatesTags: ["Job"],
        }),
        updateQuote: builder.mutation({
            query: ({ job_id, data, quote_id }) => {          
              return {
                url: `contractor/job/${job_id}/quote/${quote_id}`,
                method: "PUT",
                body: data,
              };
            },
            invalidatesTags: ["Job"],
          }),
          acceptQuote: builder.mutation({
            query: ({ job_id, quote_id }) => {
              return {
                url: `contractor/job/${job_id}/quote/${quote_id}/action?action=accept`,
                method: "PUT",
                body: {},
              };
            },
            invalidatesTags: ["Job"],
          }),
          completeJob: builder.mutation({
            query: ({ job_id, data}) => {
              return {
                url: `contractor/job/${job_id}/complete`,
                method: "PUT",
                body: data,
              };
            },
            invalidatesTags: ["Job"],
          }),
          sendReminder: builder.mutation({
            query: ({ job_id, quote_id }) => {
              return {
                url: `contractor/job/${job_id}/quote/${quote_id}/reminder`,
                method: "PUT",
                body: {},
              };
            },
            invalidatesTags: ["Job"],
          }),
          createInvoice: builder.mutation({
            query: (data) => ({
                url: `contractor/invoice`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Job"],
        }),
        getDefaultAndEstimatorSettingItems: builder.query({
            query: ({ type }) => {
                return {
                    url: `contractor/job/default/estimator_setting?type=${type}`,
                    method: "GET",
                }
              },
            providesTags: ["Job"],
        })
    }),

});

export const {
    useGetAllJobsQuery,
    useGetJobByIdQuery,
    useAddJobMutation, 
    useUpdateJobMutation,
    useDeleteJobMutation,
    useGetAllJobTypesQuery,
    useGetEstimatorTemplateQuery,
    useCreateEstimateMutation,
    useCreateQuoteMutation,
    useGetJobByDatesQuery,
    useAssignTechnicianToJobMutation,
    useCancelJobMutation,
    useUpdateQuoteMutation,
    useAcceptQuoteMutation,
    useCompleteJobMutation,
    useSendReminderMutation,
    useCreateInvoiceMutation,
    useGetDefaultAndEstimatorSettingItemsQuery,
} = jobsApi;
